import React, { Component } from 'react'
import { Button, Form, Table, Input, Row, Col, Modal, DatePicker, Radio,Switch,message,Icon } from 'antd'
import moment from 'moment'

import { getStaff,addStaff,editStaff} from '_src/api/api'

import PrevImg from '_src/components/PrevImg/PrevImg'
import '_src/common/style/common.less' 

const { Search } = Input

@Form.create({ name: '' })
class ReturnForm extends Component {
  constructor (props) {
    super(props)
	this.date = moment().format('YYYY-MM-DD')
    // 参数集合
    this.param = {
      mobile: '', // 手机号
      pageNum: 0,
	  totalElements: 0,
	  company:''
    }
    this.state = {
      	loading: true,
      	dataList: [],
		createModelVisible:false
    }
  }

  componentDidMount () {
    this.loadData()
  }
  loadData () {
    this.setState({loading: true})
    const { pageNum, mobile,company } = this.param
    let param = {pageNum,  pageSize: 10 ,mobile, company}   
    // 获取列表信息
    getStaff(param)
      .then(res=>{
        const { data } = res
        this.param.totalElements = data.totalElements
        const dataList = data.content.map(item=>{
          return {...item, key: item.id, id: item.id}
        })
        this.setState({
          dataList: dataList,
          loading: false,
        })
      })
  }
  
  columns = () => {
    return [
      {
        title: <span>姓名</span>,
        align: 'center',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: <span>手机号</span>,
        align: 'center',
        dataIndex: 'mobile',
      },
      {
        title: <span>公司名称</span>,
        align: 'center',
        dataIndex: 'company',
      },

      {
        title: <span>性别</span>,
        align: 'center',
		dataIndex: 'gender',
		render: item => {
            return <div>{item === 0 ? '女': '男'}</div>
          }
      },     

      {
        title: <span>出生日期</span>,
        align: 'center',
        dataIndex: 'bornIn',
      },
      {
        title: <span>账号是否启用</span>,
		align: 'center',
		dataIndex: 'enable',
		render: item => <div>{item === true ? <Icon type="check-circle" theme="twoTone" style={{ color: 'green', fontSize: 20 }} /> : <Icon type="close-circle" theme="filled" style={{ color: '#ccc', fontSize: 18 }} />}</div>
      },
      {
        title: <span>操作</span>,
        align: 'center',
        width: 280,
        render: item => <div>
          <Button icon="edit" onClick={() => { this.edit(item) }}>编辑</Button>
        </div>,
      },
    ]
  }

  // 搜索
  handleSearch = (key, value) => {
    this.param[key] = value
    this.param.pageNum = 0
    this.loadData()
  }
  pangeChange = (page) => {
    this.param.pageNum = (page - 1)
    this.loadData()
  }

  handleChangeDate = (_, dateString) => {
    this.date = dateString
  }

  //添加员工
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
		values.enable = values.enable ? 1: 0
		values.bornIn = this.date
		const { info } = this.state
		const hide = message.loading('数据提交中', 0)
		if(info){
			values.id = info.id
			editStaff(values).then(res => {
				hide()
				if(res.data){
					message.success('提交成功！', 1.2, () => {
						this.setState({
							param:{
								pageNum:0
							},
							createModelVisible:false
						})
						this.loadData()
					})
				}
			})
		}else{
			addStaff(values).then(res =>{
				hide()
				if(res.data){
					message.success('提交成功！', 1.2, () => {
						this.setState({
							param:{
								pageNum:0
							},
							createModelVisible:false
						})
						this.loadData()
					})
				}
			})
		}
      }
    })
  }
   // 编辑
	edit = (item) => {
		this.setState({
			info: item,
			createModelVisible: true,
		})
		this.date = item.bornIn
	}
	createModal = (info) => {
		const { getFieldDecorator } = this.props.form
		const radioStyle = {
			height: '30px',
			lineHeight: '30px',
		}
		return (
		<Form onSubmit={this.handleSubmit} className="discount-form">
			<Form.Item label="姓名：" className='flex'>
			{getFieldDecorator('name', {
				rules: [{
				required: true,
				message: '请输入员工姓名',
				}],
				initialValue: info && info.name ? info.name : '' ,
			})(
				<Input placeholder="姓名" />
			)}
			</Form.Item>

			<Form.Item label="手机号：" className='flex'>
			{getFieldDecorator('mobile', {
				rules: [{
				required: true,
				message: '请输入手机号',
				},
				{ pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', }
				],
				initialValue:  info && info.mobile ? info.mobile : '',
			})(
				<Input placeholder="手机号" type="number" />
			)}
			</Form.Item>
			<Form.Item label="公司名称：" className='flex'>
			{getFieldDecorator('company', {
				rules: [{
				required: true,
				message: '请输入公司名称',
				}],
				initialValue: info && info.company ? info.company : '',
			})(
				<Input placeholder="公司名称" />
			)}
			</Form.Item>
			<Form.Item label="性别：" className='flex'>
			{getFieldDecorator('gender', {
				rules: [{
				required: true,
				message: '请选择性别',
				}],
				initialValue: info ? info.gender : ''
			})(
				<Radio.Group
				onChange={(e) => {
					this.setState({ type: e.target.value })
				}}
				>
				<Radio style={radioStyle} value={0}>女</Radio>
				<Radio style={radioStyle} value={1}>男</Radio>
				</Radio.Group>
			)}
			</Form.Item>
			<Form.Item label="出生日期：" className='flex'>
				<DatePicker onChange = {this.handleChangeDate} defaultValue = {info ? moment(info.bornIn) : moment()} /> 
			</Form.Item>
			<Form.Item label="使用状态：" className='flex'>
			{getFieldDecorator('enable', {
				valuePropName: 'checked',
				initialValue: info && info.enable === true ? 1: 0
			})(
				<Switch checkedChildren="启用" unCheckedChildren="禁用" />
			)}
			</Form.Item>
			<Form.Item>
			<Button type="primary" htmlType="submit" disabled={this.state.issubmit} style={{ width: 300, marginLeft: 10 }}>保存</Button>
			</Form.Item>

		</Form>
		)
	}

  render () {
    const { dataList, loading,createModelVisible,info } = this.state
    const { pageNum, totalElements } = this.param
    
    return (
      <div className = "ReturnForm page_content" >
        <PrevImg ref={el => this.PrevImg = el} />   
        <Form className = "goodlist_from">
          <div style = {{maxWidth: 900}}>
			<Row gutter = {24}>
				<Col span = {6}>
					<Button className="addBtn" type="primary" icon="plus" onClick={() =>{
						this.setState({
							createModelVisible:true
						})
					}}>添加员工</Button>
				</Col>
				<Col span = {8}>
					<Form.Item label = "手机号">
					<Search placeholder="请输入手机号" onSearch={(v)=>{ this.handleSearch('mobile', v) }}enterButton />
					</Form.Item>
				</Col>
				<Col span = {8}>
					<Form.Item label = "公司名称">
					<Search placeholder="请输入公司名称" onSearch={(v)=>{ this.handleSearch('company', v) }}enterButton />
					</Form.Item>
				</Col>
            </Row>
          </div>
        </Form>
        
        <Table
          loading = {loading} 
          bordered
          columns = {this.columns()} 
          dataSource = {dataList}
          pagination = {{ 
            current: (pageNum + 1),
            total: totalElements,
            onChange: (page) => { this.pangeChange(page) }
          }}
        />
		<Modal
          title={info ? '编辑' :'添加员工'}
          visible={createModelVisible}
          onCancel={() => {
            this.setState({
              createModelVisible: false,
              info: '',
            })
          }}
          width={400}
          footer={false}
          destroyOnClose
        >
          {this.createModal(info)}
        </Modal>
      </div>
    )
  }
}


export default ReturnForm